import React, { useContext, useEffect } from "react";
import DetailLayout from "../../components/DetailLayout";
import style from "./index.module.scss";
import TopicList from "./components/TopicList";
import TopicDetail from "./components/TopicDetail";
import { RouteComponentProps, useHistory } from "react-router-dom";
import CourseHeader from "../../components/CourseHeader";
import {
    questionnaireIdAtom,
    exerciseInfoAtom,
    selectedIdAtom,
    selectedIndexAtom,
    selectedQuestion,
    SortQuestionList,
    staticsAtom,
    useNavigateQuestion
} from "service/stores/Question/Statics";
import { useAtomValue, useSetAtom } from "jotai";
import { Button } from "antd";
import { useKeyPressEvent } from "react-use";
import WithProvider from "components/WithProvider";
import { CourseContext } from "../../Store";
import BriefInfo from "../Components/BriefInfo";

interface QuestionStaticsProps {
    questionnaireId: string;
}

function QuestionStatics({}: RouteComponentProps<QuestionStaticsProps>) {
    const exerciseInfo = useAtomValue(exerciseInfoAtom);
    const selectedIndex = useAtomValue(selectedIndexAtom);
    const selectQuestion = useSetAtom(selectedIdAtom);
    const question = useAtomValue(selectedQuestion(selectedIndex));
    const { questionList, joinPercent } = useAtomValue(staticsAtom);
    const orderList = useAtomValue(SortQuestionList);
    const { goPrev, goNext } = useNavigateQuestion();

    useKeyPressEvent("ArrowLeft", goPrev);
    useKeyPressEvent("ArrowRight", goNext);

    // 上来选定第一题
    useEffect(() => {
        if (questionList.length === 0) return;
        selectQuestion(question.id);
    }, [questionList]);

    const { basename } = useContext(CourseContext);
    const history = useHistory();
    return (
        <DetailLayout breadcrumb="问卷详情">
            <CourseHeader
                title={exerciseInfo.questionnaireName}
                info={<BriefInfo {...exerciseInfo} />}
                extra={
                    <span className={style.percent}>参与率{joinPercent}</span>
                }
            />

            <div className={style.buttonRow}>
                <Button
                    onClick={() =>
                        history.replace(
                            `${basename}/question/students/${exerciseInfo.questionnaireId}`
                        )
                    }>
                    查看参与情况
                </Button>
            </div>

            <div className={style.main}>
                <div className={style.left}>
                    <TopicList
                        selectedIndex={selectedIndex}
                        questionList={orderList}
                    />
                </div>

                <div className={style.right}>
                    <TopicDetail index={selectedIndex} data={question} />

                    <div className={style.footer}>
                        {selectedIndex !== 0 && (
                            <Button
                                type="link"
                                onClick={goPrev}
                                className={style.prev}>
                                上一题
                            </Button>
                        )}
                        {selectedIndex < questionList.length - 1 && (
                            <Button
                                type="link"
                                onClick={goNext}
                                className={style.next}>
                                下一题
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </DetailLayout>
    );
}

export default WithProvider(QuestionStatics, ({ match }) => [
    [questionnaireIdAtom, match.params.questionnaireId]
]);
